import AScene from "../../library/ExtendedObjects/AScene"
import AImage from "../../library/ExtendedObjects/AImage.js";
import LocationData from "./LocationData.js";
import gameData from "../../gameData.js";
import muteButton from "../../library/muteButton";
import ABCyaPhaser, { Audio } from "@abcya/abcya_phaser";
import LocalizationSoundAssetKeys from "../../Localization-SoundAssetKeys";
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Candle extends AScene
{
    static get KEY() { return 'Candle'; }
    create()
        {
            this.count1 = 0;
            var display;
            this.RunTimes = 0;
            this.RopeArray = [];
            this.BalloonArray = [];
            this.NumberImageArray = [];
            this.CandleImageArray = [];
            this.Instructions;
            this.CakeImage;
            this.CakeRandom;
            this.KidImage;
            this.Cloud;
            this.LastNumber = 0;
            this.NumbersUsed = [0,0,0,0,0,0,0,0,0,0];
            //this.HowOldBalloon;
            this.GameWin = 0;
            this.ProgressBar = [];
            this.TableImage;
            this.FinalCakesArray = [];
            this.TempFire;
            this.DepthList;
            this.UsedCakeList = [0,1,2,3,4,5,6,8,9]; 
            var CandleRandomNumber = 9;
            this.DisplayBar;
            this.CanReadNumbers = false;
            this.HowOldIsReading = this.playSound("how_old_is",1,false,false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.InstructionsReading = this.playSound("click_on_the_candles", 1,false,false, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.NameReading = this.playSound("jake_jellybean", 1,false,false, Audio.LOCALIZATION_AUDIO_SPRITE);

            let particles = this.add.particles('particleAtlas');

            this.emitter = particles.createEmitter({
                frame: [
                    "Pop_1.png",
                    "Pop_2.png",
                    "Pop_3.png",
                    "Pop_4.png",
                    "Pop_5.png",
                    "Pop_6.png",
                    "Pop_7.png",
                    "Pop_8.png",
                    "Pop_9.png",
                    "Pop_10.png",
                    "Pop_11.png",
                    "Pop_12.png"
                ],
                on: false,
                x: 400,
                y: 300,
                frequency: 2000,
                maxParticles: 0,
                active:true,blendMode:0,gravityX:50,gravityY:800,particleBringToTop:true,radial:true,timeScale:1,accelerationX:0,accelerationY:0,angle:{min:0,max:360},lifespan:2000,maxVelocityX:10000,maxVelocityY:10000,moveToX:0,moveToY:0,quantity:{min:4,max:9},rotate:0,speed:{min:100,max:510}
            });

            this.KidContainer;

            
            //this.FlashTimer = this.addDelay(10000,()=>{this.FlashInteractives();});
            //this.FlashTimer.paused = true;

            this.cont = this.add.group();
            this.candleCont = this.add.group();
            this.DisplayGroup = this.add.group();

            this.DepthList = LocationData.DepthListSend();

            particles.setDepth(this.DepthList.BalloonNumberAndConfetti);

            let {KidCakePair, CandleLocation} = LocationData.CKCLocations();

            this.KidCakePair = KidCakePair;
            this.CandleLocation = CandleLocation;

            this.addImage(this.mid.x, this.mid.y, "G_bg", this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
            this.DisplayBar = this.addImage(this.mid.x, 50, "Display.png",this.D);
            this.DisplayBar.setDepth(this.DepthList.Display);
            this.ProgressBar[0] = this.addImage(this.mid.x-103, 50, "Unplayed.png");
            this.ProgressBar[1] = this.addImage(this.mid.x-51, 50, "Unplayed.png");
            this.ProgressBar[2] = this.addImage(this.mid.x, 50, "Unplayed.png");
            this.ProgressBar[3] = this.addImage(this.mid.x+51, 50, "Unplayed.png");
            this.ProgressBar[4] = this.addImage(this.mid.x+103, 50, "Unplayed.png");
            this.addTween(this.DisplayBar,400, {y: {start:this.DisplayBar.y - 100, to: this.DisplayBar.y}});
            for (let i in this.ProgressBar)
            {
                this.addTween(this.ProgressBar[i],400, {y: {start:this.ProgressBar[i].y - 100, to: this.ProgressBar[i].y}});
                this.DisplayGroup.add(this.ProgressBar[i]);
                this.ProgressBar[i].setDepth(this.DepthList.DisplayFire);
            }


            this.Cloud = this.addImage(-500, 76, "NewAsset/Cloud_Large.png");
            
            this.HowOldIsText = this.add.text(-500, 80, "How old is",{
                fontFamily: 'snigletregular',
                fontSize: 48, 
                color:'#06ADC9',
                padding: {x: 4, y: 4},
                //strokeThickness: 1,
                shadow: {
                    offsetX: -1,
                    offsetY: .5,
                    stroke: true,
                    color: "#0C7189",
                    fill: true
                }
            });
            this.HowOldIsText.setOrigin(.5,.5);

            this.PauseBackDrop = this.add.rectangle(0,0,1024,768,'#333840',.3);
            this.PauseBackDrop.setOrigin(0,0);
            this.PauseBackDrop.setDepth(this.DepthList.PauseBackDrop);
            this.PauseBackDrop.setVisible(false);

            this.AddHomeButton();
            muteButton(this, this.DepthList.Instructions);

            this.ButtonRollIn(this.HomeButton,700,Phaser.Math.Easing.Linear,false);

            if (this.SoundOnButton.visible === false)
            {
                this.ButtonRollIn(this.SoundOffButton,700,Phaser.Math.Easing.Linear,true);
            }
            else 
            {
                this.ButtonRollIn(this.SoundOnButton,700,Phaser.Math.Easing.Linear,true);
            }


            this.NewCake("start", "Create");
            if (this.GameWin != 0)//this logic is for dev tools. To skip to make a cake for testing
            {
              // note - this doesn't work perfectly
              this.time.delayedCall(3500, ()=>{
                this.TableImage = this.addImage(this.mid.x, this.mid.y + this.mid.y - 105, "Table.png");
                this.cont.add(this.TableImage);
                this.TableImage.setDepth(this.DepthList.Table);
                
                this.TableExit();
              });
            }
            
                
//Dev tools
/*
            this.input.keyboard.on('keydown', ()=> {
                console.log(event.key);
                if (event.key != "Tab" && event.key != "Enter" && event.key != "Alt" && event.key != "Control" && event.key != "Shift"){
                    console.log(event.key);
                    if(event.altKey == true)
                    {
                        this.RunTimes = 1;
                        this.DestroyBalloon(1);
                        console.log("Calling Cleanup with dev tools");
                        this.CleanUp(1);
                        this.NewCake((event.key),"Dev Tools");
                        if (event.key == 6 || event.key == 9)
                        {
                            //alert("The fire on these candles is curently out of order, only accessable using dev tools");
                        }
                    }
                    else{
                        CandleRandomNumber = event.key;
                        if (CandleRandomNumber == 0) CandleRandomNumber = 10;
                        this.candleCont.clear(true,true);
                        console.log(CandleRandomNumber);
                        this.CandlePlace(CandleRandomNumber);
                        this.SetCandlesInteractive(CandleRandomNumber);
                    }
                }   
                else if(event.key == "Shift")
                {
                    console.log("Shift");
                    display = "CandleLocation["+this.CakeRandom+"][1] = [";
                    display += "[" + Math.round(this.CandleImageArray[0].x) +","+ Math.round(this.CandleImageArray[0].y) + "],";
                    for (let i=1; i<(CandleRandomNumber + 1); i+=2) 
                        {
                            display += "[" + (Math.round(this.CandleImageArray[0].x) + (i*20)) + ",";
                            display +=  (Math.round(this.CandleImageArray[0].y)) + "],";
                            display += "[" + (Math.round(this.CandleImageArray[0].x) - (i*20)) + ",";
                            display +=  (Math.round(this.CandleImageArray[0].y)) + "],";
                        }
                    console.log(display);
                }
                else if(event.key == "Enter")
                {
                    console.log(CandleRandomNumber);
                    if ((CandleRandomNumber%2) == 0)
                    {
                        display = "CandleLocation["+this.CakeRandom+"][0] = [";
                        for (let i=0; i<CandleRandomNumber; i++) 
                        {
                            if (this.CandleImageArray[i].x <= 80)
                            {
                                console.log("broke at: "+ i);
                                break;
                            }

                            if (i != (CandleRandomNumber-1) && i > 0)
                            {
                                display += ",";
                            }

                            console.log(this.CandleImageArray[i].x);
                            //this.CandleLocation[this.CakeRandom][i][0]=this.CandleImageArray[i].x;
                            display += "[" + Math.round(this.CandleImageArray[i].x) +","+ Math.round(this.CandleImageArray[i].y);
                            if (this.CandleImageArray[i].depth == 9)
                            {
                                display += "," + "true";
                            }
                            if (this.CandleImageArray[i].rotation != 0)
                            {
                                if (this.CandleImageArray[i].depth != 9)
                                {
                                    display += "," + "false";  
                                }
                                display += "," + (this.CandleImageArray[i].rotation) + "]";
                            }
                            else
                            { 
                                display += "]";
                            }
                        }
                    }
                    else
                    {
                        display = "CandleLocation["+this.CakeRandom+"][1] = [";
                        for (let i=0; i<CandleRandomNumber; i++) 
                        {
                            if (this.CandleImageArray[i].x <= 80)
                            {
                                console.log("broke at: "+ i);
                                break;
                            }

                            if (i != (CandleRandomNumber-1) && i > 0)
                            {
                                display += ",";
                            }

                            console.log(this.CandleImageArray[i].x + " y: " + this.CandleImageArray[i].y);
                            //this.CandleLocation[this.CakeRandom][i][0]=this.CandleImageArray[i].x;
                            display += "[" + Math.round(this.CandleImageArray[i].x) +","+ Math.round(this.CandleImageArray[i].y);
                            if (this.CandleImageArray[i].depth == 9)
                            {
                                display += "," + "true";
                            }
                            if (this.CandleImageArray[i].rotation != 0)
                            {
                                if (this.CandleImageArray[i].depth != 9)
                                {
                                    display += "," + "false";  
                                }
                                display += "," + (this.CandleImageArray[i].rotation) + "]";
                            }
                            else
                            { 
                                display += "]";
                            }
                        }
                    }
                    display += "];";
                    console.log(display);
                    
                }
        
            });
            */
//End devtools

            /*
                this.input.on('gameobjectover', function (pointer, gameObject) 
                {
                    gameObject.setTint(0x7878ff);
                });

                this.input.on('gameobjectout', function (pointer, gameObject) 
                {
                    gameObject.clearTint();
                });
                */
        }

    SummonEndBalloons()
        {
            var PlayABalloon;
            var MakeBalloon;
            var EndBalloonGroup = this.add.group();
            var BalloonArray = [];
            var StringArray = [];
            var BalloonRiseSound;

            
            MakeBalloon = this.add.container(835, 168, 
              [
                this.addImage(0,0,"NewAsset/Decorate_Cake_Balloon.png"),
                ABCyaPhaser.Text.addText(2,51, 32, 0xd4d2ff,FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("well_done_screen.decorate_a_cake_balloon"), this).setShadow(-2,2, "#7753db").setWordWrapWidth(160).setLineSpacing(-10)
              ]);

            PlayABalloon = this.add.container(189, 168, 
              [
                this.addImage(0,0,"NewAsset/Play_Again_Balloon.png"),
                ABCyaPhaser.Text.addText(2,45, 32, 0xd4d2ff,FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("well_done_screen.play_again_balloon"), this).setShadow(-2,2, "#7753db").setWordWrapWidth(150).setLineSpacing(-10)
              ]); 

            BalloonArray = [PlayABalloon, MakeBalloon];

            this.RopeArray = [];

            this.RopeArray[0] = StringArray[0] = this.add.rope(BalloonArray[0].x+5, BalloonArray[0].y+200, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
            this.RopeArray[1] = StringArray[1] = this.add.rope(BalloonArray[1].x+5, BalloonArray[1].y+200, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);

            for(let x in StringArray)
            {
                StringArray[x].setColors(0x7753db);
                StringArray[x].y += 800;
                this.addTween(StringArray[x],2500,{y:StringArray[x].y - 800},Phaser.Math.Easing.Quadratic.InOut);
                StringArray[x].setDepth(this.DepthList.EndString);
            }

            EndBalloonGroup.addMultiple([PlayABalloon,MakeBalloon]);

            PlayABalloon.setDepth(this.DepthList.Instructions);
            MakeBalloon.setDepth(this.DepthList.Instructions);
            
            PlayABalloon.on('pointerdown',()=>
            {
                PlayABalloon.disableInteractive();
                this.scene.start("Intro");

            });

            MakeBalloon.on('pointerdown',()=>
            {
                MakeBalloon.disableInteractive();
                this.ToOtherScene();
                this.addDelay(800,()=>
                {
                    this.scene.start("MakeACake");
                });
            });

            if (gameData.gameMuted != true)
            {
                BalloonRiseSound = this.playSound("balloons_rising",1);
            }

            this.addDelay(2010,()=>
            {
                this.playSound("play_again_or_decorate_cake", 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
            });
            
            EndBalloonGroup.getChildren().forEach((child)=>
            {
                //console.log(child);
                child.y += 800;
                this.addTween(child,2500,{y:child.y - 800},Phaser.Math.Easing.Quadratic.InOut,()=>{
                    ABCyaPhaser.Container.setContainerInteractive(MakeBalloon, false);
                    ABCyaPhaser.Container.setContainerInteractive(PlayABalloon, false);
                    this.EndBalloonBounce(StringArray, BalloonArray);
                });
            });
        }
        
    EndBalloonBounce(string,Balloon)
        {
            var RandomBalloonHeight;
            var x;
            var RandomTime;
            for (x in Balloon)
            {
                RandomTime = Math.floor(Math.random() * 500)+1100;
                RandomBalloonHeight = Math.floor(Math.random() * 10)+5;
                this.addTween(Balloon[x], RandomTime, {y: Balloon[x].y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
                this.addTween(string[x], RandomTime, {y: string[x].y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
            }
        }

    ToOtherScene()
        {
            let bg = this.addImage(this.mid.x, this.mid.y+this.mid.y+this.mid.y, "Background.png");
            bg.setDepth(this.DepthList.YesNoBtn);
            if (gameData.gameMuted != true)
            {
                this.playSound("tween_up");
            }
            this.addTween(bg,800,{x:this.mid.x,y:this.mid.y},Phaser.Math.Easing.Quadratic.Out);
        }

    AddHomeButton()
        {   
            var MenuBack;
            var YesBtn;
            var NoBtn;
            this.HomeBtnGroup = this.add.group();
            var ClearGroup = this.add.group();
            var Quit;

            this.HomeButton = this.addButton(50,this.mid.y + this.mid.y - 40, "NewAsset/Btn_Home.png", null, ()=>{
                this.sound.pauseAll();
                Quit = this.playSound(LocalizationSoundAssetKeys._are_you_sure_you_want_to_quit, 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);

                this.HomeButton.setEnabled(false);

                this.PauseBackDrop.setVisible(true);
                this.PauseBackDrop.setInteractive();

                //this.scene.pause();
                //this.scene.launch("PauseMenu");

                let menuBg = this.addImage(this.mid.x,this.mid.y,"NewAsset/Quit_Popup.png").setDepth(this.DepthList.Menu);
                MenuBack = ABCyaPhaser.Text.addText(522, 314,60, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.quit_text"), this).setShadow(-4, 1,"#f58a1f").setWordWrapWidth(550).setPadding(4,4);
                MenuBack.setDepth(this.DepthList.Menu);

                YesBtn = this.addButton(this.mid.x - 148.75,this.mid.y,"Yes.png");
                let yesBtnTxt = ABCyaPhaser.Text.addText(365, 442,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.yes_button"), this).setShadow(-4, 1,"#f58a1f").setPadding(4,4)
                NoBtn = this.addButton(this.mid.x + 148.75,this.mid.y,"No.png");
                let noBtnTxt = ABCyaPhaser.Text.addText(664, 441,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.no_button"), this).setShadow(-4, 1,"#f58a1f")

                YesBtn.setDepth(this.DepthList.YesNoBtn);
                yesBtnTxt.setDepth(this.DepthList.YesNoBtn);
                NoBtn.setDepth(this.DepthList.YesNoBtn);
                noBtnTxt.setDepth(this.DepthList.YesNoBtn);
                this.HomeBtnGroup.addMultiple([YesBtn,NoBtn,MenuBack]);

                YesBtn.on('pointerdown',()=>
                {
                        YesBtn.setEnabled(false);
                        NoBtn.setEnabled(false);
                        this.sound.stopAll();
                        this.scene.start("Intro");
                });

                NoBtn.on('pointerdown',()=>
                {
                        YesBtn.setEnabled(false);
                        NoBtn.setEnabled(false);
                        //console.log("pressed no");
                        //console.log(this.HomeBtnGroup);
                        this.DestroyMenu(YesBtn,NoBtn,MenuBack, menuBg, yesBtnTxt, noBtnTxt);
                        this.sound.resumeAll();
                        Quit.stop();
                        this.PauseBackDrop.setVisible(false);
                        this.PauseBackDrop.disableInteractive();
                });
            });
            this.HomeButton.soundKey = "button_menu_click";
            if(gameData.gameMuted === true)
                {
                    this.HomeButton.PlaySound = false;
                }
            this.HomeButton.setOrigin(.5,.5);
            this.HomeButton.setDepth(this.DepthList.Instructions);

        }
    
    DestroyMenu(Y,N,M, BG, yTxt, nTxt)
        {
            Y.destroy();
            N.destroy();
            M.destroy();
            BG.destroy();
            yTxt.destroy();
            nTxt.destroy();
            this.addDelay(100)
            {
                this.HomeButton.setEnabled(true);
            }
        }

    SetScaleBySize(CurrentSize,SizeToBe,SmallerLarger,Min,Max)
        {//Function that can be used to scale a backgroung image to a changing in size foreground image

            var FinalAnswer;
            if (isNaN(Min) == false && SizeToBe < Min)
            {
                SizeToBe = Min;
            }

            if (isNaN(Max) == false && SizeToBe > Max)
            {
                SizeToBe = Max;
            }

            FinalAnswer = ((SizeToBe/CurrentSize)+(SmallerLarger/CurrentSize));
            return(FinalAnswer);
        }

    NewCake(key,SentFrom)
        {
            var ZeroOrOne;
            var CandleLength;
            var CandleRandomNumber;
            var PosistionToDelete;

            //console.log("NEWCAKE!"+SentFrom)
            ZeroOrOne = (Math.floor(Math.random() * 2));
            this.TableImage = this.addImage(this.mid.x, this.mid.y + this.mid.y - 105, "Table.png");
            this.cont.add(this.TableImage);
            this.TableImage.setDepth(this.DepthList.Table);
            if (this.RunTimes == 0) // done once to make sure instructions only appear once
                {
                    this.CakeRandom = ZeroOrOne;
                    this.UsedCakeList.splice((this.UsedCakeList.indexOf(this.CakeRandom)),1);
                    this.CakeRandom += this.AltTextureCheck();
                    CandleLength = this.CandleLocation[this.CakeRandom][ZeroOrOne].length;
                    CandleRandomNumber = (Math.floor(Math.random() * (CandleLength))+1);
                    this.NumbersUsed[CandleRandomNumber-1] = CandleRandomNumber;
                    
                    this.Instructions = ABCyaPhaser.Text.addText(this.mid.x, this.scale.height-45, 38, 0xf9a11e, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.bottom_instructions"), this, true).setWordWrapWidth(650).setLineSpacing(-8);
                    this.addTween(this.Instructions,400, {y: {start:this.Instructions.y + 100, to: this.Instructions.y},delay:1500});

                    this.Instructions.setDepth(this.DepthList.Instructions);
                    this.cont.add(this.Instructions);
                    this.addDelay(2000, ()=>{
                        this.BlinkEye(this.Eye2,this.Eye1);
                    });
                
                    //this.BalloonPlace(CandleRandomNumber);
                }
            else
                {      

                    if (isNaN(key) == true)
                    {
                        PosistionToDelete = Math.floor(Math.random() * this.UsedCakeList.length);
                        this.CakeRandom = this.UsedCakeList[PosistionToDelete];
                        this.UsedCakeList.splice(PosistionToDelete,1);
                        //console.log(this.UsedCakeList);
                        this.CakeRandom += this.AltTextureCheck();   
                    }
                    else
                    {
                        this.CloudAndTextPosistionReset();
                        this.CakeRandom = Number(key);//add ten here to get alt skins
                    }
                    CandleLength = this.CandleLocation[this.CakeRandom][ZeroOrOne].length;//This is because without zero or one, it will always return 1 or 2.
                    //CandleRandomNumber = (Math.floor(Math.random() * (CandleLength))+1);//because array structure is [cake][oddoreven][number of candles][x,y,depth,roatation]
                    CandleRandomNumber = this.CandleRepeatCheck(this.CakeRandom);
                }

            this.CandlePlace(CandleRandomNumber);

            this.HowOldIsText.text = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.how_old_prompt") + "\n" + this.KidCakePair[this.CakeRandom].kid_name + "?";
            ABCyaPhaser.Text.resizeFontToFitWidth(this.HowOldIsText, ABCyaLib.Environment.instance.gameConfig.maxHowOldIsTextWidth, 125, 48)
            this.HowOldIsText.setAlign('center');

            this.Cloud.setScale(this.SetScaleBySize(this.Cloud.width,this.HowOldIsText.width,50,310));
            if (this.RunTimes != 0)
            {
                this.HowOldTextTween("In");
            }

            this.KidAndCakePlace(this.KidCakePair[this.CakeRandom],CandleRandomNumber);

        }

    CandleRepeatCheck(Cake)
        {
            var Length;
            var PossibleNumArray = [];
            var RandNum;
            
            if (this.CandleLocation[Cake][0].length > this.CandleLocation[Cake][1].length)
            {
                Length = this.CandleLocation[Cake][0].length;
            }
            else
            {
                Length = this.CandleLocation[Cake][1].length;
            }

            for (let x = 0; x < Length; x++)
            {
                if(this.NumbersUsed[x] != (x+1))
                {
                    PossibleNumArray.push(x+1);
                }
            }
            //console.log("Possible nums" + PossibleNumArray);

            RandNum = Math.floor(Math.random() * PossibleNumArray.length);
            RandNum = PossibleNumArray[RandNum];
            this.NumbersUsed[(RandNum-1)] = RandNum;
            //console.log(this.NumbersUsed);
            //console.log(RandNum);
            return RandNum;
        }

    AltTextureCheck()
        {
            if((Math.floor(Math.random() * 2)) === 0)
            {
                return (0);
            }
            else
            {
                return(10);
            }
        }

    CandlePlace(CandleRandomNumber)
        {
            this.TempFire = [];
            var OddOrEven = CandleRandomNumber%2;
            var x;
            var CheckCandles = 0;
            //this.CandleImageArray = [0];

            for (let i=0; i<CandleRandomNumber; i++) 
                {
                    this.TempFire[i]="empty";
                    this.CandleImageArray[i] = this.addImage(this.CandleLocation[this.CakeRandom][OddOrEven][i][0], this.CandleLocation[this.CakeRandom][OddOrEven][i][1], "Candle_blue.png");
                    this.candleCont.add(this.CandleImageArray[i]);
                    this.CandleImageArray[i].setDepth(this.DepthList.Candles);
                    this.CandleImageArray[i].scale = 1;
                    this.CandleImageArray[i].setCrop(5,0,24,116);
                    //if (this.CakeRandom === 6)this.add.rectangle(this.CandleImageArray[i].x,this.CandleImageArray.y,10,10,0x30f043,1);
                    

                    this.CandleImageArray[i].flipX = true;

                    if (this.CandleLocation[this.CakeRandom][OddOrEven][i].length > 2)
                    {
                        if (this.CandleLocation[this.CakeRandom][OddOrEven][i][2] == true)
                        {
                            //console.log("Move on down");
                            this.CandleImageArray[i].setDepth(this.DepthList.CandlesBehind);
                        }

                        //if (this.CandleLocation[this.CakeRandom][OddOrEven][i][3] != 0 && this.CandleLocation[this.CakeRandom][OddOrEven][i].length > 3)
                        //{
                            //fires = this.addImage(this.CandleImageArray[i].getTopRight().x,this.CandleImageArray[i].getTopLeft().y, "Candle_flame.png");

                            //FireContainer[i] = this.add.container(this.CandleImageArray[i].x,this.CandleImageArray[i].y);
                            //FireContainer[i].add(fires);
                            //FireContainer[i].add(this.CandleImageArray[i]);
                            //this.CandleImageArray[i].x = 0;
                            //this.CandleImageArray[i].y = 0;

                            //this.CandleImageArray[i].rotation = this.CandleLocation[this.CakeRandom][OddOrEven][i][3];
                            /*
                            console.log(this.CandleImageArray[i].y);
                            y = this.CandleImageArray[i].y;
                            console.log(y);
                            this.CandleImageArray[i].setOrigin(.75,.5);
                            this.CandleImageArray[i].x -= 9;
                            rect = this.add.rectangle(this.CandleImageArray[i].x,y,10,10,0xf03d30,1);
                            console.log(this.Ca)
                            fires = this.addImage(this.CandleImageArray[i].getTopRight().x,this.CandleImageArray[i].getTopLeft().y, "Candle_flame.png");
                            fires.setScale(.5);
                            fires.setOrigin(.5,1);
                            rect.setDepth(30);
                            */

                            //console.log("rotated");
                        //}
                    }
                    ///*
                    this.CandleImageArray[i].on('pointerdown', ()=>
                    {
                        //if 
                        this.CandleImageArray[i].disableInteractive();
                        this.TempFire[i]= this.addImage(this.CandleImageArray[i].x+23,this.CandleImageArray[i].y-this.CandleImageArray[i].height/2, "Candle_bigflame.png");
                        this.TempFire[i].setOrigin(.5,1);
                        this.TempFire[i].setScale(.1,.1);
                        this.TempFire[i].setDepth(this.DepthList.FireInFront);
                        this.TempFire[i].setAlpha(5);
                        this.CandleFireTween(this.TempFire[i],i);
                        CheckCandles++;
                        //if(this.CanReadNumbers)
                        //{
                        this.NumberDuck(CheckCandles);

                        //}
                        if (CheckCandles == CandleRandomNumber)
                        {
                            this.BalloonPlace(CandleRandomNumber);
                        }
                    });

                this.CandleImageArray[i].on('pointerover', function () 
                    {
                        this.setTint(0x7878ff);
                    });

                this.CandleImageArray[i].on('pointerout', function () 
                    {
                        this.clearTint();
                    });
                   // */
                }
        }
    
    NumberDuck(CheckCandles)
        {
            this.NumberSoundPlay(CheckCandles);

            if(this.InstructionsReading.isPlaying) 
            {
                this.InstructionsReading.volume = .2;
            }
            if(this.HowOldIsReading.isPlaying) 
            {
                this.HowOldIsReading.volume = .2;
            }
            if(this.NameReading.isPlaying) 
            {
                this.NameReading.volume = .2;
            }
        }

    NumberUnduck()
        {
            this.InstructionsReading.volume = 1;
            this.HowOldIsReading.volume = 1;
            this.NameReading.volume = 1;
        }

    NumberSoundPlay(CheckCandles)
        {
            var sound;
            let soundKey = '';
            switch (CheckCandles)
            {
                case 1:
                    soundKey = 'one';
                    //gameData.bgMusic.play("one");
                    break;
                case 2:
                    soundKey = 'two';
                    //gameData.bgMusic.play("one");
                    break;
                case 3:
                    soundKey = 'three';
                    //gameData.bgMusic.play("one");
                    break;
                case 4:
                    soundKey = 'four';
                    //gameData.bgMusic.play("one");
                    break;
                case 5:
                    soundKey = 'five';
                    //gameData.bgMusic.play("one");
                    break;
                case 6:
                    soundKey = 'six';
                    //gameData.bgMusic.play("one");
                    break;
                case 7:
                    soundKey = 'seven';
                    //gameData.bgMusic.play("one");
                    break;
                case 8:
                    soundKey = 'eight';
                    //gameData.bgMusic.play("one");
                    break;
                case 9:
                    soundKey = 'nine';
                    //gameData.bgMusic.play("one");
                    break;
                case 10:
                    soundKey = 'ten';
                    //gameData.bgMusic.play("one");
                    break;
            }
            sound = this.playSound(soundKey, 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
            sound.once('complete', ()=>{this.NumberUnduck()});
        }

    BalloonPlace(CandleRandomNumber)
        {
            //This Function is to place the numbers at random heights, and to make sure the numbers are all different
            let Looper;
            
            let ForLoopCheck=0;
            let RandomNumberArray = [];
            let RandomNumberArraySource = [1,2,3,4,5,6,7,8,9,10];
            var BalloonLocationTween = [];

            this.BalloonArray[0] = this.addImage(739, 1000, "NewAsset/Answer_Balloon.png");
            this.BalloonArray[1] = this.addImage(856, 1000, "NewAsset/Answer_Balloon.png");
            this.BalloonArray[2] = this.addImage(965, 1000, "NewAsset/Answer_Balloon.png");

            if (this.RopeArray.length != 0)
            {
                for (Looper in this.RopeArray)
                {
                    //console.log("destroying");
                    this.RopeArray[Looper].destroy();
                }
            }
            
            this.RopeArray[0] = this.add.rope(739, 1163, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
            this.RopeArray[1] = this.add.rope(856, 1163, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
            this.RopeArray[2] = this.add.rope(965, 1163, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);

            //seed the display number array, and ensure that the correct number is always in the array
            for (let h = 0; h < 3; h++)
            {
                if (h === 0)
                {
                    RandomNumberArray[h] = RandomNumberArraySource.splice((CandleRandomNumber-1),1);
                }
                else
                {
                    RandomNumberArray[h] = RandomNumberArraySource.splice(Math.floor(Math.random() * RandomNumberArraySource.length),1);
                }
            }

            //Set balloon height
            for(Looper in this.BalloonArray)
            {
                this.BalloonArray[Looper].scale = .4;
                this.BalloonArray[Looper].setDepth(this.DepthList.Balloon);
                this.RopeArray[Looper].setDepth(this.DepthList.String);
                this.RopeArray[Looper].setScale(.75,.5);
                this.RopeArray[Looper].setColors(0x25889f);
                BalloonLocationTween[Looper] = (Math.floor(Math.random() * 184) + 182);
            }
            
            for (let Looper in this.BalloonArray)
            {
                let h = Math.floor(Math.random() * RandomNumberArray.length);
                if ((h === 0) && (ForLoopCheck === 0))
                {
                    ForLoopCheck++;
                    this.BalloonArray[Looper].setState(Looper);//This is used to identify each Balloon and Number pair. State is a variable tied to AImage, carried through by Phaser
                    this.NumberImageArray[Looper] = this.addImage(this.BalloonArray[Looper].x+3,this.BalloonArray[Looper].y-75, "Blue/Age/Age_"+RandomNumberArray.splice(h,1)+"_1.png");
                    this.BalloonArray[Looper].on('pointerdown', function ()
                    {
                        //console.log(this);
                        this.disableInteractive();
                        this.scene.BalloonCorrect(this);//Scope is passed here because .on listeners change the scope of this to the object clicked on
                    });
                }
                else
                {   this.BalloonArray[Looper].state = Looper;
                    this.NumberImageArray[Looper] = this.addImage(this.BalloonArray[Looper].x+3,this.BalloonArray[Looper].y-75, "Blue/Age/Age_"+RandomNumberArray.splice(h,1)+"_1.png");
                    this.BalloonArray[Looper].on('pointerdown', function ()
                    {
                        this.disableInteractive();
                        this.scene.BalloonIncorrect(this);//Scope is passed here because .on listeners change the scope of this to the object clicked on
                    });
                }
                this.BalloonArray[Looper].on('pointerover', function () 
                    {
                        this.setTint(0x7878ff);
                    });

                    this.BalloonArray[Looper].on('pointerout', function () 
                    {
                        this.clearTint();
                    });
            }


            for (Looper in this.NumberImageArray)
            {
                this.NumberImageArray[Looper].scale = .45;
                this.NumberImageArray[Looper].alpha = 0;
                this.NumberImageArray[Looper].y = BalloonLocationTween[Looper];
                //this.NumberImageArray[Looper].x += 3;
                this.NumberImageArray[Looper].setDepth(this.DepthList.BalloonNumberAndConfetti);
            }

            this.addDelay(500, ()=>
            {
                if (gameData.gameMuted != true)
                {
                    this.playSound("tween_up",1);
                }
            });

            for (Looper in BalloonLocationTween)
            {
            //this.BalloonArray[Looper].depth = 0;
            this.addTween(this.RopeArray[Looper], 2000,{y: BalloonLocationTween[Looper]-1000+1100}, Phaser.Math.Easing.Quadratic.Out);
            this.addTween(this.BalloonArray[Looper], 2000,{y: BalloonLocationTween[Looper] }, Phaser.Math.Easing.Quadratic.Out,()=> {
                for (Looper in this.BalloonArray)this.BalloonArray[Looper].setInteractive();
            });
            }

             this.addDelay(2000, ()=>{
                for (Looper in this.NumberImageArray)
                {
                    this.addTween(this.NumberImageArray[Looper], 100, {alpha: 1},Phaser.Math.Easing.Linear.In);
                    if (Looper == 2)
                    {
                        this.addDelay(110, ()=>{this.BalloonIdleTween();});
                    }
                }
            });
        }

    DestroyBalloon(Devpass)
        {
            for(let Looper in this.BalloonArray)
            {
                this.BalloonArray[Looper].destroy();
                this.NumberImageArray[Looper].destroy();
            }

            //console.log("Destroy Balloon: " + Devpass);
            if (Devpass != 1)this.CakeExit();
            if (this.GameWin == 1)this.CakeExit();
        }

    BalloonIncorrect(BalloonPassed,DriftDown)
        {
            if (gameData.gameMuted != true && DriftDown != true)
            {
                this.playSound("incorrect_answer",1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
            }
            var RopeRef = this.RopeArray[BalloonPassed.state];
            this.addTween(this.NumberImageArray[BalloonPassed.state], 100, {alpha: 0, yoyo:false}, Phaser.Math.Easing.Linear.Out,()=>{
                this.addTween(RopeRef, 2000, {y: 1200, yoyo:false}, Phaser.Math.Easing.Linear.Out,()=>{
                    this.tweens.killTweensOf(RopeRef);
                });
                this.addTween(BalloonPassed, 2000, {y: 1200, yoyo:false}, Phaser.Math.Easing.Linear.Out,()=>
                {
                    //console.log(this.tweens.getTweensOf(BalloonPassed)[0]);
                    this.tweens.getTweensOf(BalloonPassed)[0].pause();
                });
            });
        }

    BalloonCorrect(BalloonPassed)
        {   
            var x;
            var OtherBalloons = [0,1,2];
            var ConfettiDropTween;
            var RopeRef;
            OtherBalloons.splice(BalloonPassed.state,1);
            BalloonPassed.setDepth(this.DepthList.VictoryBalloon);

            for (let x in this.tweens.getTweensOf(this.NumberImageArray[BalloonPassed.state]))
            {
                this.tweens.getTweensOf(this.NumberImageArray[BalloonPassed.state])[x].pause();
            }

            for (let x in this.tweens.getTweensOf(BalloonPassed))
            {
                this.tweens.getTweensOf(BalloonPassed)[x].pause();
            }

            for (x in this.BalloonArray)
            {
                this.BalloonArray[x].disableInteractive();
            }

            for (let x in OtherBalloons)
            {
                this.BalloonIncorrect(this.BalloonArray[OtherBalloons[x]],true);
            }

            //console.log("Balloon Correct: "+this.RunTimes);

            RopeRef = this.RopeArray[BalloonPassed.state];

            //this.addTween(RopeRef, 800, {x: 840, y: 275, scale:.25, alpha: 0}, Phaser.Math.Easing.Quadratic.Out);
            //this.addTween(RopeRef, 1000, {x:RopeRef.x + (840-BalloonPassed.x), y:RopeRef.y + (275-BalloonPassed.y),scale:.75}, Phaser.Math.Easing.Quadratic.Out);
            //this.addTween(BalloonPassed, 800, {x: 840, y: 275, scale:1}, Phaser.Math.Easing.Quadratic.Out,()=>
            //{   
            RopeRef.setVisible(false);
            if (gameData.gameMuted != true)
            {
                this.playSound("correct_answer",1);  
            }
            this.BalloonPop1(BalloonPassed,this.emitter); 
            this.addDelay(100,()=>
            {
                //this.addTween(BalloonPassed, 400, {scaleY: 1},Phaser.Math.Easing.Elastic.In,()=>
                //{
                    RopeRef.setVisible(false);
                    BalloonPassed.destroy();
                    //this.BalloonArray[BalloonPassed.state] = this.addImage(this.NumberImageArray[BalloonPassed.state].x,this.NumberImageArray[BalloonPassed.state].y+53, "Blue/Popped Balloon/Pop_blue.png");
                    //this.BalloonArray[BalloonPassed.state].scale = 1;
                    //this.BalloonArray[BalloonPassed.state].setDepth(this.DepthList.BalloonNumberAndConfetti);
                    // ConfettiDropTween = this.addTween(this.BalloonArray[BalloonPassed.state], 900, {y: 750, yoyo:false}, Phaser.Math.Easing.Quadratic.in);
                    this.addDelay(1100,()=>{
                        this.ProgressCounter();
                        this.addTween(this.NumberImageArray[BalloonPassed.state], 200, {alpha: 0, scale: 0,  yoyo:false,}, Phaser.Math.Easing.Quadratic.Out); 
                    });
                //});
            });
            //});
            this.addTween(this.NumberImageArray[BalloonPassed.state], 800, {x: 843, y: 275, scale:1}, Phaser.Math.Easing.Quadratic.Out);
        }

    ProgressCounter(TweenFromX,TweenFromY)
        {  
            var DisplayLength = this.ProgressBar.length;
            //this.ProgressBar[this.RunTimes+DisplayLength] = this.addImage(843,275, "Played.png");
            this.ProgressBar[this.RunTimes+DisplayLength] = this.addImage(this.ProgressBar[this.RunTimes].x,this.ProgressBar[0].y, "Played.png");
            this.ProgressBar[this.RunTimes+DisplayLength].setAlpha(0);
            this.ProgressBar[this.RunTimes+DisplayLength].setScale(1.5);

            //this.addDelay(350,()=>
            //{
                if (gameData.gameMuted != true)
                {
                    this.playSound("flame_counter",1);
                }
            //});
            this.addTween(this.ProgressBar[this.RunTimes+DisplayLength], 200, {alpha: {start: 0, to:1}, scale: {start: 0, to:1.5}, yoyo:false,}, Phaser.Math.Easing.Quadratic.Out,()=>
            {
                this.addTween(this.ProgressBar[this.RunTimes+DisplayLength], 100, {scale: 1, yoyo:false,}, Phaser.Math.Easing.Quadratic.Out);
                //this.addTween(this.ProgressBar[this.RunTimes+DisplayLength], 500, {x: this.ProgressBar[this.RunTimes].x, y: this.ProgressBar[0].y, yoyo:false,}, Phaser.Math.Easing.Quadratic.Out,()=>
                //{
                    //this.addTween(this.ProgressBar[this.RunTimes+DisplayLength], 10, {scale: 1, yoyo:true}, Phaser.Math.Easing.Elastic.Out);
                    if (this.RunTimes === 0)
                    {
                        this.addTween(this.Instructions,1000,{y:this.Instructions.y + 100});
                    }
                    this.RunTimes++;
                    if (this.RunTimes == 5)
                    {
                        //console.log("win state!")
                        this.GameWin = 1;
                    }
                    this.HowOldTextTween("Out");
                    this.DestroyBalloon(this.GameWin);
                //});
            });
            this.ProgressBar[this.RunTimes+DisplayLength].setDepth(this.DepthList.DisplayCompleteFire);
            this.DisplayGroup.add(this.ProgressBar[this.RunTimes+DisplayLength]);
        }

    KidAndCakePlace(KidCakePair,CandleRandomNumber)
        {
            var CandleTweenRef;
            var OffScreenLeft = -200;
            var OffScreenRight = 1400;
            var CakeTravelTime = 1500;
            var CloudEnterTime = 2000;
            var KidTravelTime;
            var i = 0;
            var CandleTweenTime;
            var CakeTravelSpeed;
            var ContainerOriginOffset = KidCakePair.kid_ContainerOffSet;
            var CakeSideTween;
            var InstructionsReading;
            var WaveCandle = [];

            this.CanReadNumbers = false;

            this.KidContainer = this.add.container(KidCakePair.kid_xCord,KidCakePair.kid_yCord+ContainerOriginOffset);
            this.KidImage = this.addImage(0, -ContainerOriginOffset, KidCakePair.kid_imagesrc);
            this.Eye1 = this.addImage(KidCakePair.kid_eye1.x-KidCakePair.kid_xCord,KidCakePair.kid_eye1.y-KidCakePair.kid_yCord-ContainerOriginOffset, KidCakePair.kid_eyesrc,this.KidContainer);
            this.Eye2 = this.addImage(KidCakePair.kid_eye2.x-KidCakePair.kid_xCord,KidCakePair.kid_eye2.y-KidCakePair.kid_yCord-ContainerOriginOffset, KidCakePair.kid_eyesrc,this.KidContainer);

            this.KidContainer.add(this.KidImage);
            this.KidContainer.setVisible(false);

            this.EaseWalkIn(this.KidContainer,KidCakePair.kid_xCord);

            this.KidContainer.sendToBack(this.KidImage);

            KidTravelTime = this.KidEnter(KidCakePair.kid_xCord,true);

            this.CakeImage = this.addImage(OffScreenRight, KidCakePair.cake_yCord, KidCakePair.cake_imagesrc);
            this.cont.add(this.CakeImage);
            if (this.CakeRandom == 5 || this.CakeRandom == 15)this.CakeImage.setScale(.80);
            this.CakeImage.setDepth(this.DepthList.Cake);
            CakeTravelSpeed = (OffScreenRight - KidCakePair.cake_xCord) / CakeTravelTime;

            CakeSideTween = this.addTween(this.CakeImage, 1120, {x:KidCakePair.cake_xCord, yoyo:false}, Phaser.Math.Easing.Quadratic.InOut);
            
            CakeSideTween.on('start',()=>
                {

                    if(gameData.gameMuted != true)
                    {
                        this.playSound("cake_slide_in",1);
                    }

                });

            CakeSideTween.on('complete',()=>
                {
                    //console.log(this.RunTimes);
                    if (this.RunTimes === 0)
                    {
                        this.addDelay(590,()=>
                        {
                            this.InstructionsReading.play("click_on_the_candles");

                            this.addDelay(1400,()=>
                                {
                                    //WaveCandle = this.CandleImageArray;

                                    for (i = 0; i < CandleRandomNumber;i++)
                                    {
                                        WaveCandle[i] = this.CandleImageArray[i];
                                    }
                                    WaveCandle.sort(function (a,b)
                                    {
                                        return a.x - b.x;
                                    });
                                    for (i = 0; i < CandleRandomNumber;i++)
                                    {
                                        //this.CandleImageArray[i].setTint(0x7878ff);
                                        this.addTween(WaveCandle[i],250,{y:WaveCandle[i].y - 50, scale:1.3,yoyo:true, delay: i * 100});
                                    }

                                    this.addDelay(100,()=>
                                    {
                                        for (i = 0; i < CandleRandomNumber;i++)
                                        {
                                            //this.CandleImageArray[i].clearTint();
                                        }
                                    });

                                    this.addDelay(200,()=>
                                    {
                                        for (i = 0; i < CandleRandomNumber;i++)
                                        {
                                            //this.CandleImageArray[i].setTint(0x7878ff);
                                        }
                                    });

                                    this.addDelay(300,()=>
                                    {
                                        for (i = 0; i < CandleRandomNumber;i++)
                                        {
                                            //this.CandleImageArray[i].clearTint();
                                            this.SetCandlesInteractive(CandleRandomNumber);
                                        }
                                    });
                                });

                            this.addDelay(4000,()=>
                                {
                                    this.HowOldTextTween("In");
                                });

                            this.InstructionsReading.once('complete',()=>
                            {
        
                                this.addDelay(800,()=>
                                {
                                    this.HowOldIsReading.play("how_old_is");
                                    this.HowOldIsReading.once('complete',()=>
                                    {
                                        this.NameReading = this.playSound((KidCakePair.kid_soundName),1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
                                        this.NameReading.once('complete',()=>
                                        {
                                            this.CanReadNumbers = true;
                                        });
                                    });
                                });
                            });
                        });
                    }

                    else
                    {

                        this.addDelay(800,()=>
                        {
                            this.HowOldIsReading.play("how_old_is");
                            this.HowOldIsReading.once('complete',()=>
                            {
                                this.NameReading = this.playSound((KidCakePair.kid_soundName),1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
                                this.NameReading.once('complete',()=>
                                {
                                    this.CanReadNumbers = true;
                                });
                            });
                        });

                    }

                });
            

            for (let z = 0;z < CandleRandomNumber;z++)
                {


                    CandleTweenRef = this.CandleImageArray[z].x;
                    this.CandleImageArray[z].x += (OffScreenRight - KidCakePair.cake_xCord);
                    CandleTweenTime = ((this.CandleImageArray[z].x - CandleTweenRef) / CakeTravelSpeed); 
                    this.addTween(this.CandleImageArray[z], 1120, {x:CandleTweenRef, yoyo:false}, Phaser.Math.Easing.Quadratic.InOut,()=>{
                        
                        if (z == (CandleRandomNumber-1))
                        {
                            if(this.RunTimes != 0)
                            {
                                this.SetCandlesInteractive(CandleRandomNumber);
                            }
                        }
                    });
                }
            // });
        }

    SetCandlesInteractive(CandleRandomNumber)
        {   var i;
            for (i = 0; i < CandleRandomNumber;i++)
            {
                this.CandleImageArray[i].setInteractive(new Phaser.Geom.Rectangle(44,0, 24, 116),Phaser.Geom.Rectangle.Contains);
            }
        }

    KidEnter(ToX,JustTime,Tweeny,Intro)
        {
            var KidImage;
            var TimeTaken;
            var PreRotateTween;
            var RotateTween;
            var ForwardTween;
            var LoopDelay = 25;
            var i;

            if (Tweeny === undefined)
            {
                KidImage = this.KidImage;
            }
            else
            {
                KidImage = Tweeny;
            }

            //KidImage = this.KidContainer;
            //console.log(KidImage);

            TimeTaken = ((ToX - KidImage.x)*2.4);
            if (JustTime === true)
            {
                return TimeTaken;
            }
            else
            {

                RotateTween = this.addTween(KidImage,300,{
                    angle: 6,
                    yoyo: true, 
                    hold: 25, 
                    loop: -1, 
                    loopDelay: LoopDelay,
                }, Phaser.Math.Easing.Linear.In);

                RotateTween.pause();

                TimeTaken = ((ToX - KidImage.x)*2.4);

                PreRotateTween = this.addTween(KidImage,350,{angle: -12}, Phaser.Math.Easing.Linear.In,()=>{
                    KidImage.angle = -12;
                    RotateTween.play();

                });

                RotateTween.on('complete',()=>{});
                //Jumptween = this.addTween(KidImage, 300,{y:KidCakePair.kid_yCord + 10, yoyo:true, loop:-1}, Phaser.Math.Easing.Quadratic.In);
                if (Intro != true)
                {

                    ForwardTween = this.addTween(KidImage, TimeTaken, {x: ToX, yoyo:false}, Phaser.Math.Easing.Quadratic.InOut,()=>{
                            RotateTween.stop();
                            //KidImage.angle = RotateTween.getValue(KidImage.angle);
                            this.addTween(KidImage,167,{angle: 0},Phaser.Math.Easing.Linear.InOut);

                        });
                }
                else
                {
                    TimeTaken = ((ToX - KidImage.x-300)*-2.4);
                    //console.log(TimeTaken);
                    ForwardTween = this.addTween(KidImage, TimeTaken, {x: {start: this.KidContainer.x - 200, to: ToX}, yoyo:false}, Phaser.Math.Easing.Quadratic.InOut,()=>{
                        RotateTween.stop();
                        //KidImage.angle = RotateTween.getValue(KidImage.angle);
                        this.addTween(KidImage,167,{angle: 0},Phaser.Math.Easing.Linear.InOut);

                    });
                    ForwardTween.on('start',()=>{this.KidContainer.setVisible(true);});
                }

                RotateTween.on('loop',()=>{
                    ForwardTween.pause();
                    this.addDelay(LoopDelay,()=> {
                        //this.addTween(KidImage,50,{y: (KidImage.y - 10), yoyo:true}, Phaser.Math.Easing.Quadratic.Out);
                        ForwardTween.resume();
                    });
                });
            this.addDelay(3000, ()=>{
                this.IdleAnimationKidTween();
            });
            return TimeTaken;
            }
        }

    KidEnterRight(ToX,Tweeny)
        {
            var KidImage;
            var TimeTaken;
            var RotateTween;
            var PreRotateTween;
            var ForwardTween;
            var LoopDelay = 25;

            if (Tweeny === undefined)
            {
                KidImage = this.KidImage;
            }
            else
            {
                KidImage = Tweeny;
            }

            TimeTaken = ((KidImage.x - ToX)*2.4);

            RotateTween = this.addTween(KidImage,300,{
                angle: -6,
                yoyo: true, 
                hold: 25, 
                loop: -1, 
                loopDelay: LoopDelay,
            }, Phaser.Math.Easing.Linear.In);

            RotateTween.pause();

            PreRotateTween = this.addTween(KidImage,350,{angle: -12}, Phaser.Math.Easing.Linear.In,()=>{
                KidImage.angle = 12;
                RotateTween.play();

            });

            RotateTween.on('complete',()=>{

            });
            //Jumptween = this.addTween(KidImage, 300,{y:KidCakePair.kid_yCord + 10, yoyo:true, loop:-1}, Phaser.Math.Easing.Quadratic.In);
           ForwardTween = this.addTween(KidImage, TimeTaken, {x: ToX, yoyo:false}, Phaser.Math.Easing.Quadratic.InOut,()=>{
                    RotateTween.stop();
                    //KidImage.angle = RotateTween.getValue(KidImage.angle);
                    this.addTween(KidImage,167,{angle: 0},Phaser.Math.Easing.Linear.InOut);
                });

            RotateTween.on('loop',()=>{
                ForwardTween.pause();
                this.addDelay(LoopDelay,()=> {
                    //this.addTween(KidImage,50,{y: (KidImage.y - 10), yoyo:true}, Phaser.Math.Easing.Quadratic.Out);
                    ForwardTween.resume();
                });
            });
           return TimeTaken;
        }

    HowOldBalloonTweenOut()
        {
            this.addTween(this.HowOldBalloon, 1600,{y:-800},Phaser.Math.Easing.Quadratic.In);
        }

        
    CloudAndTextPosistionReset()
        {
            var TextY = 86;
            var CloudY = 72;

            for (let x in this.tweens.getTweensOf(this.HowOldIsText))
            {
                this.tweens.getTweensOf(this.HowOldIsText)[x].pause();
            }

            for (let x in this.tweens.getTweensOf(this.Cloud))
            {
                this.tweens.getTweensOf(this.Cloud)[x].pause();
            }
        }

    HowOldTextTween(InOrOut,KidTimeIn,CakeTimeIn)
        {
            var LandingSpotIn = 196;
            var LandingSpotOut = -400;
            var TimeIn = 2000;
            var TimeOut = 1000;
            var TextLandingSpot;
            var EaseOut = Phaser.Math.Easing.Quadratic.InOut;

            if (InOrOut === "In")
            {
                this.HowOldIsText.x = 210 - (LandingSpotIn - this.Cloud.x);
                this.addTween(this.Cloud,TimeIn,{x: LandingSpotIn},EaseOut);
                this.addTween(this.HowOldIsText,TimeIn,{x: 210},EaseOut);
                this.CloudUp();
            }
            else if (InOrOut === "Out")
            {
                TextLandingSpot = this.HowOldIsText.x - (LandingSpotIn - LandingSpotOut);
                this.addTween(this.Cloud,TimeOut,{x: LandingSpotOut},Phaser.Math.Easing.Linear.InOut);
                this.addTween(this.HowOldIsText,TimeOut,{x: TextLandingSpot},Phaser.Math.Easing.Linear.InOut,()=>
                {
                    this.CloudAndTextPosistionReset();
                });
            }
        }

    CloudUp()
        {
            this.addTween(this.Cloud,1000,{y:this.Cloud.y+3, yoyo: true, onYoyo: ()=>{this.CloudDown();}}, Phaser.Math.Easing.Linear.Out);
            this.addTween(this.HowOldIsText,1000,{y:this.HowOldIsText.y+3, yoyo: true}, Phaser.Math.Easing.Linear.Out);
        }

    CloudDown()
        {
            this.addTween(this.Cloud,1000,{y:this.Cloud.y-3, yoyo: true, onYoyo: ()=>{this.CloudUp()}}, Phaser.Math.Easing.Linear.Out);
            this.addTween(this.HowOldIsText,1000,{y:this.HowOldIsText.y-3, yoyo: true}, Phaser.Math.Easing.Linear.Out);
        }

    CandleFireIdleTween(ToTween)
        {
                var RandomTimeFlame = Math.floor(Math.random() * 800)+1100;
                var RandomTimeFlameRotate = Math.floor(Math.random() * 800)+1100;
                var fire5 = ToTween;

                //this.addTween(ToTween, 100, {y: ToTween.y + 4, yoyo:true, loop: -1, delay: RandomTimeFlame}, Phaser.Math.Easing.Quadratic.In);
                //this.addTween(ToTween, 50, {rotation: {start: ToTween.rotation, from: ToTween.rotation+.09, to: ToTween.rotation-.1}, yoyo:true, loop: -1, delay: RandomTimeFlameRotate}, Phaser.Math.Easing.Quadratic.In);
        
                var Flamen = this.addTween(fire5, 100, {scaleY:.64, yoyo: true},Phaser.Math.Easing.Bounce.Quadratic,()=>{
                    switch(Math.floor(Math.random()*3))
                    {
                        case 0:
                            this.addTween(fire5, 100, {scaleY:.6, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                                break;
                        case 1:
                            this.addTween(fire5, 60, {scaleY:.4, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                            break;
                        case 2:
                            this.addTween(fire5, 50, {scaleY:.55, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                            break;
                    }
                });
        }

    BalloonIdleTween()
        {   
            var x;
            var TweenBalloon
            for (x in this.BalloonArray)
            {
                var RandomTime = Math.floor(Math.random() * 500)+1100;
                var RandomBallonHeight = Math.floor(Math.random() * 5)+5;
                TweenBalloon = this.addTween(this.BalloonArray[x], RandomTime, {y: this.BalloonArray[x].y + RandomBallonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
                this.addTween(this.NumberImageArray[x], RandomTime, {y: this.NumberImageArray[x].y + RandomBallonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
                this.addTween(this.RopeArray[x], RandomTime, {y: this.RopeArray[x].y + RandomBallonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
                TweenBalloon.name = "BalloonNumber" + x;
                //console.log(this.RopeArray.length);
            }
        }

    CandleFireTween(TempFire,i)
        {
            var SteadyFlame;
            this.addTween(TempFire, 150, {scale: .3}, Phaser.Math.Easing.Elastic.InOut,()=>{
                SteadyFlame = this.addImage(TempFire.x,TempFire.y,"Candle_flame.png");
                TempFire.setDepth(this.DepthList.TweenFire);
                SteadyFlame.setOrigin(.5,1);
                SteadyFlame.setScale(.1);
                SteadyFlame.setDepth(this.DepthList.FireInFront);
                SteadyFlame.x -= 3;    
                this.addTween(TempFire, 200, {scale: .1, alpha: 0}, Phaser.Math.Easing.Linear.Out,()=>
                {
                    this.TempFire[i].destroy();
                    this.TempFire[i] = SteadyFlame;
                    this.candleCont.add(this.TempFire[i]);
                });
                this.addTween(SteadyFlame, 200, {scale: .5}, Phaser.Math.Easing.Quadratic,()=>{
                    this.CandleFireIdleTween(SteadyFlame);
                });

            });
        }

    MenuAndSoundBtnTweenOut()
        {
            var SoundBtn;

            if (this.SoundOnButton.visible === true)
            {
                SoundBtn = this.SoundOnButton;
                //console.log("SoundBtn on");
            }
            else
            {
                //console.log("SoundBtn off");
                SoundBtn = this.SoundOffButton;
            }

            this.SoundOffButton.disableInteractive();
            this.SoundOnButton.disableInteractive();
            this.HomeButton.disableInteractive();

            this.addTween(this.HomeButton, 300, {y: this.HomeButton.y - 50, yoyo: true}, Phaser.Math.Easing.Quadratic.In,()=>
            {
                this.addTween(this.HomeButton, 1500, {y: 1400}, Phaser.Math.Easing.Quadratic.Out);
            });

            this.addTween(SoundBtn, 300, {y: SoundBtn.y - 50, yoyo: true}, Phaser.Math.Easing.Quadratic.In,()=>
            {
                this.addTween(SoundBtn, 1500, {y: 1400}, Phaser.Math.Easing.Quadratic.Out);
            });
        }

    CakeExit()
        {
            var KidMoveTime;
            var Kid_CakeExit = this.KidImage;
            var Cake_CakeExit = this.CakeImage;
            var i = 0;
            var CakeSpeed = ( ( (Cake_CakeExit.x + 400) *-1) /-900);
            var CandleTime;
            this.tweens.killTweensOf(this.KidContainer);
            KidMoveTime = this.EaseWalk(this.KidContainer);
            if (this.GameWin == 1)
            {
                //console.log("calling clean up cake exit gamewin true");
                this.addDelay(KidMoveTime*(3/4),()=>{this.TableExit();});
            }
            else if (this.GameWin != 1)
            {
                //console.log("calling clean up cake exit gamewin not true");
                this.addDelay(KidMoveTime*(3/4),()=>{this.CleanUp(this.GameWin);});
            }
            this.candleCont.getChildren().forEach((child)=>
            {
                CandleTime = (((((Cake_CakeExit.x + 400)*-1) - child.x)*-1)/CakeSpeed);
                this.addTween(child,CandleTime,{x: ((Cake_CakeExit.x + 400)*-1)}, Phaser.Math.Easing.Quadratic.Out);
            });            

            //this.addTween(this.candleCont,900,{x: ((Cake_CakeExit.x + 400)*-1)}, Phaser.Math.Easing.Quadratic.Out);
            
            this.addTween(Cake_CakeExit,900,{x: -400}, Phaser.Math.Easing.Quadratic.Out);
        }

    TableExit()
        {   
            var Distance;
            var TableSlideTween;
            var WellDoneText;
            var SlideUp;
            var DecoyTable = this.addImage(this.TableImage.x,this.TableImage.y, "Table.png");
            var OldY = this.TableImage.y;
            var BarContainer = this.add.container(this.ProgressBar[0].x,this.ProgressBar[0].y-50);

            Distance = 1400 - OldY;

            DecoyTable.setDepth(this.DepthList.Table);

            BarContainer.add(this.DisplayBar);
            this.DisplayBar.x -= BarContainer.x;

            for (let i in this.ProgressBar)
            {
                BarContainer.add(this.ProgressBar[i]);
                this.ProgressBar[i].x -= BarContainer.x;
                this.ProgressBar[i].y -= BarContainer.y;
                //this.ProgressBar[i].destroy();
            }
            this.addTween(BarContainer, 300, {y: -100},Phaser.Math.Easing.Quadratic,()=>
            {

                //this.addTween(WellDoneText)
            });

            //this.addImage(this.mid.x, 50, "Display.png");
            //WellDoneText = this.addImage(this.mid.x,50,"Finish.png");
            //WellDoneText.setDepth(this.DepthList.DisplayCompleteFire);
            this.MenuAndSoundBtnTweenOut(Distance);

            if (gameData.gameMuted != true)
                {
                    SlideUp = this.playSound("tween_up",1);
                    SlideUp.setRate(2);
                }
            this.addTween(DecoyTable, 500, {y: DecoyTable.y - 50, yoyo: true}, Phaser.Math.Easing.Quadratic.In,()=>
            {
                if (gameData.gameMuted != true)
                {
                    this.playSound("tween_down",1);
                }

                this.CleanUp(this.GameWin);
                TableSlideTween = this.addTween(DecoyTable, 1500, {y: 1400}, Phaser.Math.Easing.Quadratic.Out,()=>{
                    this.addTween(DecoyTable, 600, {y: OldY}, Phaser.Math.Easing.Quadratic.Out,()=>{
                        this.FinalScreenKidEnter();
                    });
                    this.FinalTable(Distance);
                    
                });
            });
        }

    FinalTable(Distance)
        {
            var i = 0;
            var DepthList = [2,2,1,2,1,1,2,2,1,1]
            var CakeLocations = LocationData.FinalScreenCakeLocations();
            if (gameData.gameMuted != true)
            {
                this.playSound("tween_up");
            }
            for (i = 0; i < 5; i++)
            {
                this.FinalCakesArray[i] = this.addImage(CakeLocations[i][0],CakeLocations[i][1] + Distance,("Cake_"+(i+1)+".png"));
                this.FinalCakesArray[i].scale = .38;
                this.FinalCakesArray[i].setDepth(this.DepthList.FireBehind + DepthList[i]);
                this.addTween(this.FinalCakesArray[i], 600, {y: CakeLocations[i][1]}, Phaser.Math.Easing.Quadratic.Out);
            }

            for (i = 5; i < 10; i++)
            {
                this.FinalCakesArray[i] = this.addImage(CakeLocations[i][0],CakeLocations[i][1] + Distance,("Cake_"+(i+1)+".png"));
                this.FinalCakesArray[i].scale = .38;
                this.FinalCakesArray[i].setDepth(this.DepthList.FireBehind + DepthList[i]);
                this.addTween(this.FinalCakesArray[i], 600, {y: CakeLocations[i][1]}, Phaser.Math.Easing.Quadratic.Out);
            }

            
        }

    FinalScreenKidEnter()
        {
            var i;
            var FinalKidsArray = [];
            var FinalKidsArrayOrder = [0,6,4,8,2,7,3,9,1,5];
            var FinalKidsLocation = LocationData.FinalScreenKidLocations();
            var DistanceOffscreenLeft;
            var kid;
            var eye1;
            var eye2;
            var WellDoneText;
            var Party;

            DistanceOffscreenLeft = (95+FinalKidsLocation[4][0]);
            for (i = 0; i < 10; i++)
            {
                
                if (i >= 5)
                {
                    FinalKidsArray[i] = this.add.container(FinalKidsLocation[i][0],FinalKidsLocation[i][1]+50);
                    kid = this.addImage(0,0, ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+".png"),FinalKidsArray[i]);
                    eye1 = this.addImage((this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[1]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    eye2 = this.addImage(-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[0]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    kid.flipX = true;
                    FinalKidsArray[i].setVisible(false);
                    this.EndScreenWalkRightIn(FinalKidsArray[i],FinalKidsLocation[i][0]);   
                }

                else
                {
                    FinalKidsArray[i] = this.add.container(FinalKidsLocation[i][0],FinalKidsLocation[i][1]+50);
                    kid = this.addImage(0,0, ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+".png"),FinalKidsArray[i]);
                    eye1 = this.addImage((this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[0]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    eye2 = this.addImage(-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[1]), 0-(this.KidCakePair[FinalKidsArrayOrder[i]].kid_eyeBoth[2]), ("NewAsset/Kids_"+((FinalKidsArrayOrder[i])+1)+"_Eye.png"),FinalKidsArray[i]);
                    FinalKidsArray[i].setVisible(false);
                    this.EndScreenWalkLeft(FinalKidsArray[i],FinalKidsLocation[i][0]);
                    
                }
                FinalKidsArray[i].scale = .55;
                FinalKidsArray[i].setDepth(this.DepthList[(FinalKidsLocation[i][2])]);
            }
           // this.addDelay(700,()=>{
            WellDoneText = this.addImage(this.mid.x,-100,"Well_Done_Large", this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
            WellDoneText.setScale(.50);
            WellDoneText.setDepth(this.DepthList.Instructions);
            if (gameData.gameMuted != true)
            {
                this.playSound("tween_down",1);
            }
            this.addTween(WellDoneText, 600, {y:175, scale: .75},Phaser.Math.Easing.Quadratic.InOut,()=>
            {
                this.addDelay(300,()=>
                {
                    this.playSound("well_done", 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
                    if (gameData.gameMuted != true)
                    {
                        Party = this.playSound("party",1);
                    }
                    this.emitter.emitParticle(25,WellDoneText.x,WellDoneText.y);
                    this.emitter.emitParticle(25,WellDoneText.x-200,WellDoneText.y);
                    this.emitter.emitParticle(25,WellDoneText.x+200,WellDoneText.y);
                    this.addDelay(2930,()=>
                    {
                        this.SummonEndBalloons();
                    });

                    //this.addDelay(700,()=>
                    //{
                    //    this.SummonEndBalloons();
                    //});
                });
            });
            
                //this.EndKidBounce(FinalKidsArray);
            //});

            this.addDelay(1700,()=>{
                this.EndKidBounce(FinalKidsArray);
            });
        }

    ButtonRollIn(object,TimeTaken,Ease,OffLeft)
        {
            var Rotation;
            var Distance;

            Distance = 6.283 * object.width/2;
            Rotation = Distance/(object.width/2);

            if (OffLeft != true)
            {
                //console.log("true");
                Distance = Distance * -1;
            }
            else
            {
            Rotation = Rotation * -1;
            }

            //Rotation = Distance/(object.width/2);

            this.addTween(object,TimeTaken,{rotation: Rotation, x: {start:object.x + Distance, to: object.x}},Ease);
        }

    IdleAnimationKidTween()
        {
            
            //this.addTween(this.KidImage, 300, {scaleX: 1.05, yoyo:true}); // looks weird
            //this.addTween(this.KidImage, 100, {delay: 2000,y: this.KidImage.y - 20, yoyo:true, repeat: 3,repeatDelay: 80},Phaser.Math.Easing.Quadratic.InOut); // looks weird
            this.addTween(this.KidContainer, 500, {angle: .4, delay: 0},Phaser.Math.Easing.Linear,()=>{
                this.addTween(this.KidContainer, 500, {angle: 0},Phaser.Math.Easing.Linear,()=>{
                    this.addTween(this.KidContainer, 500, {angle: -.4, yoyo: true},Phaser.Math.Easing.Linear,()=>{
                        if (this.GameWin != 1)
                        {
                            this.IdleAnimationKidTween();
                        }
                    })
                })
            });
        }

    BalloonPop1(exploding,emitter)
        {

            exploding.setVisible(false);
            emitter.emitParticle(25,exploding.x,exploding.y);

            this.addDelay(2000,()=>{
                exploding.setVisible(true);
                exploding.setScale(.5);
            });
        }

    EaseWalk(Tweened)
        {
            if (gameData.gameMuted != true)
                {
                    this.playSound("character_leaving_screen");
                }
            this.addTween(Tweened,200,{y:Tweened.y - 15, scaleX:.97, scaleY:1.03, loop:-1,yoyo: true});
            this.addTween(Tweened,4000,{x: 2000},Phaser.Math.Easing.Linear,()=>{
            });
            return 4000;
        }

    EaseWalkIn(Tweened,ToX)
        {
            var Time = ((Tweened.x - ToX)*2);
            var ForwardTween;

            
            this.addTween(Tweened,200,{y:Tweened.y - 10, scaleX:.97, scaleY:1.03, loop:-1,yoyo: true});
            ForwardTween = this.addTween(Tweened,800,{x: {start: -400, to: ToX}},Phaser.Math.Easing.Quadratic.Out,()=>{
                this.addTween(Tweened,75,{y: Tweened.y + 1, scaleX:1.01, scaleY:.99, yoyo: true},Phaser.Math.Easing.Quadratic.Out);
                this.tweens.killTweensOf(Tweened);
                //console.log((this.Eye2.x - this.KidImage.x)+", "+(this.KidImage.x - this.Eye1.x)+", "+(this.KidImage.y - this.Eye1.y));
            });

            ForwardTween.on('start',()=>
            {
                this.KidContainer.setVisible(true);
            });
            ForwardTween.on('complete',()=>{this.IdleAnimationKidTween();});
            
        }

    EndScreenWalkRightIn(Tweened,ToX)
        {

            
            //this.addTween(Tweened,200,{x: {start: ToX+500, to: ToX-300}});
            var ForwardTween;
            this.addTween(Tweened,200,{y:Tweened.y - 5, scaleX: .52, scaleY:.58, loop:-1,yoyo: true});
            ForwardTween = this.addTween(Tweened,1600,{x: {start: ToX + 500, to: ToX}},Phaser.Math.Easing.Quadratic.Out,()=>{
                this.tweens.killTweensOf(Tweened);
                //this.addTween(Tweened,150,{y: Tweened.y + .5, scaleX:.559, scaleY:.541, yoyo: true},Phaser.Math.Easing.Quadratic.Out);
            });
            ForwardTween.on('start',()=>{Tweened.setVisible(true);});
        }

    EndScreenWalkLeft(Tweened,ToX)
        {

            
            //this.addTween(Tweened,200,{x: {start: ToX+500, to: ToX-300}});
            var ForwardTween;
            this.addTween(Tweened,200,{y:Tweened.y - 5, scaleX: .52, scaleY:.58, loop:-1,yoyo: true});
            ForwardTween = this.addTween(Tweened,1600,{x: {start: ToX - 500, to: ToX}},Phaser.Math.Easing.Quadratic.Out,()=>{
                this.tweens.killTweensOf(Tweened);
            });
            ForwardTween.on('start',()=>{Tweened.setVisible(true);});
        }

    EndKidBounce(Kids)
        {
            var RandomHeight;
            var x;
            var RandomTime;
            var RandomDelay = 200;
            var Time;
            var Stretch;
            var JumpSquat = [];
            var RandomBlinkTime;
            var Tween;
            var PreStretch = .02;


            for (x in Kids)
            {
                RandomDelay = 200;
                RandomTime = Math.floor(Math.random() * 100)+300;
                RandomHeight = Math.floor(Math.random() * 20)+30;
                RandomDelay += Math.floor(Math.random() * 500)+100;
                RandomBlinkTime = (Math.floor(Math.random() * 1000) + 1500);

                Time = RandomHeight*5;
                Stretch = RandomHeight*.0004;

                JumpSquat[x] = this.tweens.createTimeline()
                JumpSquat[x].loop = -1;
                JumpSquat[x].loopDelay = RandomTime;

                
                JumpSquat[x].add({targets: Kids[x], duration: 100,delay: RandomDelay, scaleY: Kids[x].scaleY - PreStretch, scaleX: Kids[x].scaleX + PreStretch, hold:100, yoyo: true, ease: 'Quadatic'});
                JumpSquat[x].add({targets: Kids[x], duration: 200, scaleY: Kids[x].scaleY + Stretch, scaleX: Kids[x].scaleX - Stretch, y: Kids[x].y - 60, ease: 'Quadratic',yoyo: true});
                JumpSquat[x].add({targets: Kids[x], duration: 90, scaleY: Kids[x].scaleY - Stretch, scaleX: Kids[x].scaleX + Stretch, yoyo: true,});
                JumpSquat[x].play();

                RandomTime = Math.floor(Math.random() * 1000)+50;

                Tween = this.add.tween({targets: [ Kids[x].list[1], Kids[x].list[2] ],duration:7, delay: RandomTime, scaleY: .2,loop: -1, yoyo: true, hold:80, loopDelay: RandomBlinkTime +1000});
            }
            //console.log(Kids[1].list[0]); 
        }
        

    BlinkEye(Eye1,Eye2)
        {
            var RandomBlinkTime = (Math.floor(Math.random() * 1000) + 1500);
            this.addDelay(RandomBlinkTime, ()=>{
                
                Eye1.setScale(1,.2);
                Eye2.setScale(1,.2);
                this.addDelay(90,()=>
                {
                    Eye1.setScale(1,1);
                    Eye2.setScale(1,1);
                });

                this.addDelay(RandomBlinkTime+1000, ()=>{
                    if (this.GameWin != 1)
                    {
                        this.BlinkEye(this.Eye2,this.Eye1);
                    }
                });
            });
        }

    CleanUp(Devpass)
        {
            var i = 0;
            if (Devpass == 1)
            {
                //console.log("Clean up Dev");
                this.KidContainer.destroy();
                this.cont.clear(true,true);
                this.candleCont.clear(true,true);
            }

            else
            {
                //console.log("Clean up");
                this.KidContainer.destroy();
                this.cont.clear(false,true);
                this.candleCont.clear(true,true);
                this.NewCake();
            }
        }

    update()
    {
        this.count1 += .1;


        if (this.RopeArray.length != 0 && this.RopeArray.length === 3)
        {
            var points = [
                this.RopeArray[0].points,
                this.RopeArray[1].points,
                this.RopeArray[2].points
            ];

            for (let i = 7; i < points[0].length; i++)
            {
                    points[0][i].x = Math.sin(i * .3 - this.count1) * 3;
            }
            this.RopeArray[0].setDirty();


            //let points1 = this.RopeArray[1].points;

            for (let i = 7; i < points[1].length; i++)
            {
                    points[1][i].x = Math.sin(i * .19 - this.count1) * 2.5;
            }
            this.RopeArray[1].setDirty();


            //let points2 = this.RopeArray[2].points;

            for (let i = 7; i < points[2].length; i++)
            {
                    points[2][i].x = Math.sin(i * .25 - this.count1) * 2.7;
            }
            this.RopeArray[2].setDirty();
        }
        else if(this.RopeArray.length===2)
        {
            var points = [
                this.RopeArray[0].points,
                this.RopeArray[1].points,
            ];

            for (let i = 7; i < points[0].length; i++)
            {
                    points[0][i].x = Math.sin(i * .3 - this.count1) * 3;
            }
            this.RopeArray[0].setDirty();


            //let points1 = this.RopeArray[1].points;

            for (let i = 7; i < points[1].length; i++)
            {
                    points[1][i].x = Math.sin(i * .27 - this.count1) * 2.9;
            }
            this.RopeArray[1].setDirty();

        }
    
    }
}